export default "/images/vendor/flag-icon-css/flags/1x1/gg.svg?e9d7238c94cc4589ac0ee16c9d7009c9";